// Fictional company "Yasna", a direct-to-consumer cosmetics brand launching the
// "Hydra" line this month. See README.md for the schema.
export default {
  id: 'marketing-manager',
  occupationId: '66b280672a4e4285b87eb995',
  occupationName: { en: 'Marketing manager', ua: 'Маркетолог' },
  format: 'messenger',
  title: { en: 'A day as a marketing manager', ua: 'День маркетолога' },
  tagline: {
    en: 'Two days to launch, one budget, a founder who wants a viral video and a review that is spreading',
    ua: 'Два дні до запуску, один бюджет, засновниця, яка хоче вірусне відео, і відгук, що розлітається'
  },
  minutes: 10,
  intro: {
    en: 'You run marketing at "Yasna", a direct-to-consumer cosmetics brand with 25 people and its own online shop. The new "Hydra" skincare line launches on Thursday. It is Tuesday: the media plan is approved, the landing page is in design, the agency is on standby, and everyone has one more idea.',
    ua: 'Ти ведеш маркетинг у «Ясна», косметичному бренді на 25 людей із власним онлайн-магазином. Нова лінійка догляду Hydra виходить у четвер. Сьогодні вівторок: медіаплан затверджено, лендинг у дизайні, агенція напоготові, і в кожного є ще одна ідея.'
  },
  goal: {
    en: 'Launch on Thursday with the budget on the right bets and the brand still trusted',
    ua: 'Запуститися в четвер із бюджетом на правильних ставках і брендом, якому досі довіряють'
  },
  kpis: [
    { key: 'reach', label: { en: 'Reach', ua: 'Охоплення' }, start: 50 },
    { key: 'conversion', label: { en: 'Conversion', ua: 'Конверсія' }, start: 55 },
    { key: 'brand', label: { en: 'Brand trust', ua: 'Довіра до бренду' }, start: 65 }
  ],
  competencies: [
    {
      key: 'strategy',
      label: { en: 'Strategy', ua: 'Стратегія' },
      skill: { _id: 'f49b20511e3b534b03b4bb15', name: 'Маркетингова стратегія' }
    },
    {
      key: 'analytics',
      label: { en: 'Analytics', ua: 'Аналітика' },
      skill: { _id: '686282c1aa8e5a92e3bc1744', name: 'Аналітика даних (Google Analytics, Hotjar)' }
    },
    {
      key: 'creativity',
      label: { en: 'Creativity', ua: 'Креативність' },
      skill: { _id: '686282c1aa8e5a92e3bc13a4', name: 'Креативність' }
    },
    {
      key: 'communication',
      label: { en: 'Communication', ua: 'Комунікація' },
      skill: { _id: '686282c1aa8e5a92e3bc133c', name: 'Комунікативність' }
    },
    {
      key: 'ethics',
      label: { en: 'Ethics', ua: 'Етика' },
      skill: { _id: '686282c1aa8e5a92e3bc1356', name: 'Відповідальність' }
    }
  ],
  people: [
    {
      key: 'founder',
      name: { en: 'Olha', ua: 'Ольга' },
      role: { en: 'Founder', ua: 'Засновниця' },
      initials: 'OL',
      color: '#9c27b0'
    },
    {
      key: 'sales',
      name: { en: 'Roman', ua: 'Роман' },
      role: { en: 'Head of sales', ua: 'Керівник продажів' },
      initials: 'RO',
      color: '#d5921b'
    },
    {
      key: 'designer',
      name: { en: 'Yana', ua: 'Яна' },
      role: { en: 'Designer', ua: 'Дизайнерка' },
      initials: 'YA',
      color: '#e25510'
    },
    {
      key: 'agency',
      name: { en: 'Ihor', ua: 'Ігор' },
      role: { en: 'Agency account manager', ua: 'Акаунт-менеджер агенції' },
      initials: 'IH',
      color: '#30b0c7'
    },
    {
      key: 'support',
      name: { en: 'Khrystyna', ua: 'Христина' },
      role: { en: 'Customer care lead', ua: 'Керівниця служби турботи' },
      initials: 'KH',
      color: '#19857b'
    }
  ],
  steps: [
    {
      type: 'allocate',
      id: 's1',
      at: '09:00',
      comp: ['strategy', 'analytics'],
      traits: ['E', 'I'],
      text: {
        en: 'The Hydra line launches on Thursday. The whole launch budget is 100%. Split it across channels using what each one did at the last launch.',
        ua: 'Лінійка Hydra виходить у четвер. Увесь бюджет запуску — це 100%. Розподіли його між каналами, спираючись на те, що кожен дав на минулому запуску.'
      },
      buckets: [
        {
          id: 'video',
          label: { en: 'Short-video ads', ua: 'Реклама короткими відео' },
          hint: {
            en: 'Last launch: CAC 14 € and the widest reach. The only channel that creates demand for a product nobody searches for yet.',
            ua: 'Минулий запуск: CAC 630 ₴ і найширше охоплення. Єдиний канал, що створює попит на продукт, який поки ніхто не шукає.'
          },
          best: 35
        },
        {
          id: 'search',
          label: { en: 'Search ads', ua: 'Пошукова реклама' },
          hint: {
            en: 'Last launch: CAC 9 €, but searches for a new line are tiny until people have heard of it.',
            ua: 'Минулий запуск: CAC 400 ₴, але пошуків нової лінійки майже немає, поки про неї не почули.'
          },
          best: 25
        },
        {
          id: 'creators',
          label: { en: 'Creators', ua: 'Блогери' },
          hint: {
            en: 'Last launch: CAC 11 €. Six creators shortlisted, two still need an audience check.',
            ua: 'Минулий запуск: CAC 500 ₴. Шість блогерів у шорт-листі, двох ще треба перевірити на аудиторію.'
          },
          best: 25
        },
        {
          id: 'email',
          label: { en: 'Email and CRM', ua: 'Email і CRM' },
          hint: {
            en: '38 000 subscribers, CAC 2 €. The list is finite: beyond about 15% of the budget it buys nothing extra.',
            ua: '38 000 підписників, CAC 90 ₴. База скінченна: понад приблизно 15% бюджету нічого додатково не дає.'
          },
          best: 15
        }
      ],
      explain: {
        en: 'Video takes the largest share because a new line needs demand before anyone can capture it. Search is cheap per customer but only converts demand that already exists, so a quarter. Creators earn a quarter once the two unverified audiences are checked. Email is the cheapest channel of all, and 15% already covers the whole list.',
        ua: 'Відео отримує найбільшу частку, бо новій лінійці спершу потрібен попит, а вже потім його можна збирати. Пошук дешевий у розрахунку на клієнта, але конвертує лише той попит, який уже є, тому чверть. Блогери — чверть після перевірки двох аудиторій. Email найдешевший з усіх, і 15% уже покривають усю базу.'
      },
      fx: { ok: { reach: 6, conversion: 4 }, fail: { reach: -5 } }
    },
    {
      type: 'numeric',
      id: 's2',
      at: '09:45',
      comp: ['analytics'],
      traits: ['I', 'C'],
      text: {
        en: 'Ihor sends last week’s paid-social numbers for the teaser campaign and asks whether it is on target. Count refunds; the finance team does.',
        ua: 'Ігор надсилає показники платних соцмереж за минулий тиждень по тизерній кампанії й питає, чи вона в цілі. Повернення враховуй; фінансисти враховують.'
      },
      data: [
        { label: { en: 'Ad spend', ua: 'Витрати на рекламу' }, value: '48 000' },
        { label: { en: 'Revenue from ads', ua: 'Виручка з реклами' }, value: '168 000' },
        { label: { en: 'Refunds', ua: 'Повернення' }, value: '12 000' },
        { label: { en: 'Target ROAS', ua: 'Цільовий ROAS' }, value: '3.0' }
      ],
      question: {
        en: 'What is the ROAS on net revenue, after refunds?',
        ua: 'Який ROAS за чистою виручкою, після повернень?'
      },
      answer: 3.25,
      tolerance: 0.03,
      unit: { en: '×', ua: '×' },
      hint: {
        en: 'Take refunds out of revenue first, then divide by spend.',
        ua: 'Спершу відніми повернення від виручки, потім поділи на витрати.'
      },
      explain: {
        en: '168 000 − 12 000 = 156 000 net revenue. 156 000 ÷ 48 000 = 3.25, above the 3.0 target. Gross ROAS would be 3.5, which is the number an agency usually reports.',
        ua: '168 000 − 12 000 = 156 000 чистої виручки. 156 000 ÷ 48 000 = 3,25, вище за ціль 3,0. Валовий ROAS був би 3,5 — саме цю цифру агенція зазвичай і показує.'
      },
      fx: { ok: { conversion: 5 }, fail: { conversion: -4 } }
    },
    {
      type: 'chat',
      id: 's3',
      at: '10:30',
      comp: ['creativity', 'communication'],
      traits: ['E', 'A'],
      messages: [
        {
          from: 'founder',
          text: {
            en: 'I just watched a tiny brand get 4 million views on one video. Forget the media plan, I want one viral short video for Hydra. Can we put everything into that?',
            ua: 'Щойно бачила, як крихітний бренд зібрав 4 мільйони переглядів одним відео. Забудь про медіаплан, я хочу одне вірусне коротке відео для Hydra. Можемо вкласти все в нього?'
          }
        },
        {
          from: 'founder',
          text: {
            en: 'Thursday is in two days. Be honest.',
            ua: 'Четвер за два дні. Чесно.'
          }
        }
      ],
      prompt: { en: 'What do you say to Olha?', ua: 'Що кажеш Ользі?' },
      options: [
        {
          text: {
            en: 'Keep the plan and carve out 10% for five short-video experiments this week with one measurable goal; virality is an outcome you can fish for, not a channel you can buy.',
            ua: 'Залишити план і виділити 10% на п’ять експериментів із короткими відео цього тижня з однією вимірюваною метою; вірусність — це результат, який можна ловити, а не канал, який можна купити.'
          },
          q: 'best',
          fx: { reach: 4, trust: 4, conversion: 2 },
          fb: {
            en: 'She gets her swing at a hit without betting the launch on it. Five cheap attempts find a format; one expensive attempt finds nothing but a lesson.',
            ua: 'Вона отримує свій шанс на хіт, не ставлячи на нього весь запуск. П’ять дешевих спроб знаходять формат; одна дорога знаходить лише урок.'
          }
        },
        {
          text: {
            en: 'Agree to brief the agency on one strong video concept today and keep the rest of the plan untouched, so the launch has both the structure and a shot at the hit.',
            ua: 'Погодитися сьогодні забрифувати агенцію на один сильний відеоконцепт, а решту плану не чіпати, щоб у запуску була і структура, і шанс на хіт.'
          },
          q: 'ok',
          fx: { reach: 1, trust: 2, energy: -3 },
          fb: {
            en: 'The plan survives, but one video is one lottery ticket. Without a goal attached, the agency will report views and call it a win.',
            ua: 'План виживає, але одне відео — один лотерейний квиток. Без прив’язаної мети агенція відзвітує переглядами й назве це перемогою.'
          }
        },
        {
          text: {
            en: 'Move the whole launch budget into short video; the founder knows the audience better than anyone, and the media plan can come back after the launch week.',
            ua: 'Перекинути весь бюджет запуску на короткі відео; засновниця знає аудиторію краще за будь-кого, а медіаплан можна повернути після тижня запуску.'
          },
          q: 'bad',
          fx: { reach: -5, conversion: -7 },
          fb: {
            en: 'You traded a plan with known CACs for a hope with none. When the video gets 20 000 views, there is no search or email to catch the people who were ready to buy.',
            ua: 'Ти обміняв план із відомими CAC на надію без жодного. Коли відео збере 20 000 переглядів, не буде ні пошуку, ні розсилки, щоб підхопити тих, хто був готовий купити.'
          },
          later: {
            after: 3,
            note: {
              en: 'The agency paused search and email to free the budget for video. Search orders have been at zero since noon, and the video is still in production.',
              ua: 'Агенція поставила пошук і розсилку на паузу, щоб вивільнити бюджет під відео. Замовлень із пошуку з обіду нуль, а відео досі у виробництві.'
            },
            fx: { conversion: -4, trust: -3 }
          }
        },
        {
          text: {
            en: 'Explain that virality cannot be planned, the media plan was approved three weeks ago, and changing it two days before launch would be irresponsible.',
            ua: 'Пояснити, що вірусність не планується, медіаплан затверджено три тижні тому, а змінювати його за два дні до запуску було б безвідповідально.'
          },
          q: 'bad',
          fx: { trust: -6, reach: -2 },
          fb: {
            en: 'All true and all useless: she heard "no" and a lecture. The founder who wanted a hit will now go around you to the agency to get one.',
            ua: 'Усе правда й усе марно: вона почула «ні» й лекцію. Засновниця, яка хотіла хіт, тепер піде по нього до агенції в обхід тебе.'
          }
        }
      ],
      principle: {
        en: 'Say yes to the ambition, then put a budget and a metric on the bet.',
        ua: 'Скажи «так» амбіції, а на ставку постав бюджет і метрику.'
      }
    },
    {
      type: 'choice',
      id: 's4',
      at: '11:15',
      comp: ['analytics', 'ethics'],
      traits: ['I', 'E'],
      text: {
        en: 'The agency proposes a creator with 180 000 followers at 1 500 € per post. You check: her last ten posts average 900 likes and 12 comments, mostly emoji; followers jumped by 90 000 in a single week in March; 60% of her audience is outside the countries you ship to.',
        ua: 'Агенція пропонує блогерку зі 180 000 підписників за 65 000 ₴ за пост. Перевіряєш: останні десять постів у середньому 900 лайків і 12 коментарів, переважно емодзі; у березні за один тиждень додалося 90 000 підписників; 60% аудиторії — поза країнами, куди ви доставляєте.'
      },
      prompt: { en: 'What do you decide?', ua: 'Що вирішуєш?' },
      options: [
        {
          text: {
            en: 'Decline and tell Ihor why: 0.5% engagement and a one-week follower spike are the signature of a bought audience. Move the fee to two mid-size creators with verified audiences.',
            ua: 'Відмовити й пояснити Ігорю чому: 0,5% залученості й стрибок підписників за тиждень — це почерк купленої аудиторії. Перекинути гонорар на двох середніх блогерок із перевіреною аудиторією.'
          },
          q: 'best',
          fx: { conversion: 4, brand: 4 },
          fb: {
            en: 'The numbers are the argument, so the agency learns your standard without a fight. Two real audiences of 30 000 sell more than one fake one of 180 000.',
            ua: 'Аргумент — цифри, тож агенція засвоює твій стандарт без сварки. Дві справжні аудиторії по 30 000 продають більше за одну фальшиву на 180 000.'
          }
        },
        {
          text: {
            en: 'Offer a performance deal instead of a flat fee: commission per sale through her promo code, so a hollow audience costs you nothing and a real one pays for itself.',
            ua: 'Запропонувати оплату за результат замість фіксованого гонорару: комісія з кожного продажу за її промокодом, тож порожня аудиторія нічого не коштує, а справжня окупає себе.'
          },
          q: 'ok',
          fx: { conversion: 2, brand: -2 },
          fb: {
            en: 'Financially clever, but your brand still appears next to bought followers, and real creators talk to each other about who you work with.',
            ua: 'Фінансово розумно, але твій бренд усе одно з’являється поряд із купленими підписниками, а справжні блогери розповідають одне одному, з ким ти працюєш.'
          }
        },
        {
          text: {
            en: 'Book her: 180 000 followers at that price is the cheapest reach on the whole list, and even a small share of real fans is worth the single post.',
            ua: 'Забронювати: 180 000 підписників за таку ціну — найдешевше охоплення в усьому списку, і навіть мала частка справжніх фанів варта одного поста.'
          },
          q: 'bad',
          fx: { reach: 2, conversion: -5, brand: -4 },
          fb: {
            en: 'Reach that cannot buy is not reach; it is a number on an invoice. 900 real people saw the post, 60% of them cannot order, and the fee is gone.',
            ua: 'Охоплення, яке не купує, — не охоплення, а цифра в рахунку. Пост побачили 900 справжніх людей, 60% із них не можуть замовити, а гонорар уже витрачено.'
          }
        },
        {
          text: {
            en: 'Ask her to send screenshots of her audience statistics before deciding, and take the numbers at face value if they look healthy enough.',
            ua: 'Попросити її надіслати скриншоти статистики аудиторії перед рішенням і повірити цифрам на слово, якщо вони виглядатимуть досить здоровими.'
          },
          q: 'bad',
          fx: { energy: -3, conversion: -2 },
          fb: {
            en: 'Screenshots are edited in five minutes. The public signals you already have are harder to fake than anything she will send you.',
            ua: 'Скриншоти редагуються за п’ять хвилин. Публічні сигнали, які в тебе вже є, підробити важче, ніж будь-що, що вона надішле.'
          }
        }
      ],
      principle: {
        en: 'Engagement is the audience. Followers are only the claim.',
        ua: 'Залученість — це аудиторія. Підписники — лише заява.'
      }
    },
    {
      type: 'queue',
      id: 's5',
      at: '12:00',
      comp: ['communication', 'strategy'],
      traits: ['S', 'C'],
      text: {
        en: 'Three requests are waiting. Open them in the order you think is right and answer each.',
        ua: 'Чекають три запити. Відкрий їх у тому порядку, який вважаєш правильним, і відповідай на кожен.'
      },
      tickets: [
        {
          id: 't1',
          from: 'designer',
          urgency: 3,
          sla: { en: 'by 14:00', ua: 'до 14:00' },
          subject: {
            en: 'Final copy for the landing hero',
            ua: 'Фінальний текст для головного блоку лендингу'
          },
          body: {
            en: 'I need the final headline, three bullets and the price line by 14:00, or the landing page slips past Thursday. I have the draft from two weeks ago, is that still right?',
            ua: 'Мені потрібні фінальний заголовок, три буліти й рядок із ціною до 14:00, інакше лендинг не встигне до четверга. У мене є чернетка двотижневої давності, вона ще актуальна?'
          },
          options: [
            {
              text: {
                en: 'Send the approved headline and bullets now, take the price line from the signed price list, and mark the results claim as "pending legal" so she does not design around it.',
                ua: 'Надіслати затверджений заголовок і буліти зараз, рядок із ціною взяти з підписаного прайсу, а твердження про результат позначити «чекає на юристів», щоб вона не будувала дизайн навколо нього.'
              },
              q: 'best',
              fx: { conversion: 3, brand: 2 },
              fb: {
                en: 'She is unblocked in ten minutes, the price cannot drift from the list, and the one risky sentence is flagged instead of buried in a layout.',
                ua: 'Вона розблокована за десять хвилин, ціна не розійдеться з прайсом, а єдине ризиковане речення позначене, а не заховане в макеті.'
              }
            },
            {
              text: {
                en: 'Tell her to go ahead with the two-week-old draft so the layout gets done, and promise to polish the wording and check the price before it goes live.',
                ua: 'Сказати їй працювати з чернеткою двотижневої давності, щоб макет був готовий, і пообіцяти відшліфувати формулювання й перевірити ціну перед публікацією.'
              },
              q: 'ok',
              fx: { energy: 2, conversion: -2 },
              fb: {
                en: 'Layouts set text in stone faster than you think. "Polish later" is how an old price and an old claim reach the live page.',
                ua: 'Макети фіксують текст швидше, ніж здається. «Відшліфую потім» — саме так стара ціна й старе твердження потрапляють на живу сторінку.'
              }
            },
            {
              text: {
                en: 'Ask her to write the copy herself from the brief, since she knows the layout best and you have the founder, the agency and the influencer list to deal with.',
                ua: 'Попросити її написати текст самостійно за брифом, бо вона найкраще знає макет, а в тебе на руках засновниця, агенція і список блогерів.'
              },
              q: 'bad',
              fx: { brand: -4, trust: -3 },
              fb: {
                en: 'Copy is the one thing on that page that sells. Handing it to the designer at 12:00 on a deadline day is how typos and claims nobody approved get published.',
                ua: 'Текст — єдине на цій сторінці, що продає. Віддати його дизайнерці о 12:00 у день дедлайну — так і публікуються одруківки й твердження, яких ніхто не затверджував.'
              }
            }
          ]
        },
        {
          id: 't2',
          from: 'sales',
          urgency: 2,
          sla: { en: 'this week', ua: 'цього тижня' },
          subject: { en: 'Need 200 leads by Friday', ua: 'Потрібно 200 лідів до п’ятниці' },
          body: {
            en: 'Retail partners want to see interest before they stock Hydra. Can you run a lead-gen campaign now and send me 200 leads by Friday?',
            ua: 'Роздрібні партнери хочуть бачити інтерес, перш ніж ставити Hydra на полиці. Можеш запустити лідогенерацію зараз і надіслати мені 200 лідів до п’ятниці?'
          },
          options: [
            {
              text: {
                en: 'Ask what counts as a lead for a retail buyer, then offer what works by Friday: the 1 200 wait-list sign-ups by city as proof of demand, and a retailer page next week.',
                ua: 'Спитати, що для роздрібного байєра є лідом, і запропонувати те, що реально до п’ятниці: 1 200 записів у лист очікування за містами як доказ попиту, а сторінку для роздрібу — наступного тижня.'
              },
              q: 'best',
              fx: { conversion: 3, trust: 3 },
              fb: {
                en: 'Retail buyers want proof of demand, not a list of emails. The wait-list by city is that proof, and it already exists.',
                ua: 'Роздрібні байєри хочуть доказ попиту, а не список email-адрес. Лист очікування за містами і є цей доказ, і він уже існує.'
              }
            },
            {
              text: {
                en: 'Launch a quick lead-form campaign today with the consumer creative and a small budget, and send whatever comes in by Friday with a note on quality.',
                ua: 'Запустити сьогодні швидку кампанію з лід-формою на споживчому креативі й невеликим бюджетом, а до п’ятниці надіслати все, що прийде, з приміткою про якість.'
              },
              q: 'ok',
              fx: { reach: 1, conversion: -2, energy: -4 },
              fb: {
                en: 'You will hit a number, and Roman will show retailers 200 consumers who clicked a form. Half will be unreachable, and the launch budget paid for it.',
                ua: 'Цифру ти даси, і Роман покаже роздрібу 200 споживачів, які клікнули форму. Половина буде недосяжною, а заплатив за це бюджет запуску.'
              }
            },
            {
              text: {
                en: 'Decline: it is launch week, the budget is committed to the consumer plan, and sales can run its own outreach to retailers from the partner list.',
                ua: 'Відмовити: тиждень запуску, бюджет розписаний під споживчий план, а продажі можуть самі обдзвонити роздріб за списком партнерів.'
              },
              q: 'bad',
              fx: { trust: -5 },
              fb: {
                en: 'Retail shelf space is the other half of the launch. Roman hears that marketing works for the website, not for the brand.',
                ua: 'Полиці в роздрібі — друга половина запуску. Роман чує, що маркетинг працює на сайт, а не на бренд.'
              }
            }
          ]
        },
        {
          id: 't3',
          from: 'agency',
          urgency: 1,
          sla: { en: 'payment due in 10 days', ua: 'оплата за 10 днів' },
          subject: { en: 'Invoice for September', ua: 'Рахунок за вересень' },
          body: {
            en: 'Attached is the September invoice. Note the new line "Strategy consulting, 1 200 €"; we did extra work on the launch positioning. Let me know if anything is unclear.',
            ua: 'Надсилаю рахунок за вересень. Зверни увагу на новий рядок «Стратегічний консалтинг, 54 000 ₴»; ми додатково попрацювали над позиціюванням запуску. Пиши, якщо щось незрозуміло.'
          },
          options: [
            {
              text: {
                en: 'Hold the invoice and ask Ihor which approved brief or change request covers the consulting line; approve the rest so the agency is paid on time.',
                ua: 'Притримати рахунок і спитати Ігоря, який затверджений бриф або запит на зміни покриває рядок про консалтинг; решту погодити, щоб агенції заплатили вчасно.'
              },
              q: 'best',
              fx: { brand: 2, trust: 2 },
              fb: {
                en: 'Unapproved lines that get paid once get added every month. Paying the rest on time keeps the relationship warm while the question gets answered.',
                ua: 'Непогоджені рядки, оплачені раз, з’являтимуться щомісяця. Вчасна оплата решти тримає стосунки теплими, поки з’ясовується питання.'
              }
            },
            {
              text: {
                en: 'Approve it: 1 200 € is small next to the launch budget and you need the agency motivated this week more than you need the line explained.',
                ua: 'Погодити: 54 000 ₴ — дрібниця поряд із бюджетом запуску, а мотивована агенція цього тижня потрібніша, ніж пояснення одного рядка.'
              },
              q: 'ok',
              fx: { energy: 2, trust: -2 },
              fb: {
                en: 'Cheap this month, expensive as a precedent. Finance will ask you in October what the consulting was, and you will not know.',
                ua: 'Дешево цього місяця, дорого як прецедент. У жовтні фінансисти спитають, що це був за консалтинг, і ти не знатимеш.'
              }
            },
            {
              text: {
                en: 'Pay it in full and ask for a discount on next month’s retainer in return, which keeps everyone happy and avoids an awkward conversation mid-launch.',
                ua: 'Оплатити повністю й попросити натомість знижку на ретейнер наступного місяця, що залишить усіх задоволеними й уникне незручної розмови посеред запуску.'
              },
              q: 'bad',
              fx: { trust: -3, brand: -2 },
              fb: {
                en: 'You accepted a line you do not understand and then negotiated against your own budget. The agency learned that surprises work.',
                ua: 'Ти прийняв рядок, якого не розумієш, а потім торгувався проти власного бюджету. Агенція дізналася, що сюрпризи працюють.'
              }
            }
          ]
        }
      ]
    },
    {
      type: 'triage',
      id: 's6',
      at: '13:30',
      comp: ['strategy', 'analytics'],
      traits: ['C', 'E'],
      text: {
        en: 'Launch is Thursday 09:00. Five tasks are on the board. Put them in the order you will do them.',
        ua: 'Запуск у четвер о 09:00. На дошці п’ять задач. Розстав їх у порядку виконання.'
      },
      items: [
        {
          id: 'tracking',
          title: {
            en: 'Verify conversion tracking on the landing',
            ua: 'Перевірити трекінг конверсій на лендингу'
          },
          detail: {
            en: 'Without it Thursday’s spend is blind. One hour of work, and the agency cannot start ads until it is confirmed.',
            ua: 'Без нього витрати четверга наосліп. Година роботи, і агенція не може запускати рекламу, поки не підтверджено.'
          }
        },
        {
          id: 'landing',
          title: { en: 'Final landing-page check', ua: 'Фінальна перевірка лендингу' },
          detail: {
            en: 'Price, claims and the buy button must match the approved ads. Two hours; the page goes live Wednesday evening.',
            ua: 'Ціна, твердження й кнопка купівлі мають збігатися із затвердженою рекламою. Дві години; сторінка виходить у середу ввечері.'
          }
        },
        {
          id: 'creators',
          title: {
            en: 'Ship product and briefs to five creators',
            ua: 'Відправити продукт і брифи п’ятьом блогерам'
          },
          detail: {
            en: 'Delivery takes three days; their posts are scheduled for launch week two. Must ship by Friday.',
            ua: 'Доставка триває три дні; їхні пости заплановані на другий тиждень запуску. Відправити треба до п’ятниці.'
          }
        },
        {
          id: 'press',
          title: {
            en: 'Press kit to twelve beauty editors',
            ua: 'Прес-кіт дванадцятьом б’юті-редакторкам'
          },
          detail: {
            en: 'Embargo lifts next Monday; editors asked for materials two days before. Send by Saturday.',
            ua: 'Ембарго знімається наступного понеділка; редакторки просили матеріали за два дні. Надіслати до суботи.'
          }
        },
        {
          id: 'giveaway',
          title: { en: 'Choose the launch giveaway prize', ua: 'Обрати приз для розіграшу' },
          detail: {
            en: 'The giveaway runs in week three of the launch. Fifteen minutes whenever.',
            ua: 'Розіграш іде на третьому тижні запуску. П’ятнадцять хвилин будь-коли.'
          }
        }
      ],
      correctOrder: ['tracking', 'landing', 'creators', 'press', 'giveaway'],
      explain: {
        en: 'Tracking comes first: it takes an hour and everything measured on Thursday depends on it. The landing check is the next hard deadline, Wednesday evening. Creators ship by Friday, press by Saturday, and the giveaway prize has two weeks of slack.',
        ua: 'Спершу трекінг: це година роботи, і все, що вимірюється в четвер, залежить від нього. Перевірка лендингу — наступний жорсткий дедлайн, середа ввечері. Блогери — до п’ятниці, преса — до суботи, а приз для розіграшу має два тижні запасу.'
      },
      fx: { ok: { conversion: 4, reach: 2 }, fail: { conversion: -4, energy: -3 } }
    },
    {
      type: 'spot',
      id: 's7',
      at: '14:30',
      comp: ['ethics', 'creativity'],
      traits: ['C', 'A'],
      text: {
        en: 'Yana sends the landing-page hero for sign-off. The approved price list: Hydra serum 30 ml — 29 €, Hydra cream 50 ml — 24 €. The block has 4 mistakes. Tap each one.',
        ua: 'Яна надсилає головний блок лендингу на погодження. Затверджений прайс: сироватка Hydra 30 мл — 1 290 ₴, крем Hydra 50 мл — 1 090 ₴. У блоці 4 помилки. Натисни на кожну.'
      },
      mock: {
        kind: 'card',
        title: { en: 'Landing page — hero block, v3', ua: 'Лендинг — головний блок, v3' },
        blocks: [
          {
            id: 'h1',
            kind: 'heading',
            label: { en: 'Hydra — the new line from Yasna', ua: 'Hydra — нова лінійка від «Ясна»' },
            value: ''
          },
          {
            id: 'h2',
            kind: 'note',
            label: {
              en: 'Deep hydration for 72 hours. Dermatologist tested.',
              ua: 'Глибоке зволоження на 72 години. Перевірено дерматологами.'
            },
            value: ''
          },
          {
            id: 'h3',
            kind: 'note',
            label: { en: 'Cures acne in 7 days', ua: 'Лікує акне за 7 днів' },
            value: '',
            issue: {
              en: '"Cures acne" is a medical claim a cosmetic product may not make. Rewrite it as a cosmetic benefit or remove it.',
              ua: '«Лікує акне» — медичне твердження, якого косметика робити не може. Переписати як косметичний ефект або прибрати.'
            }
          },
          {
            id: 'h4',
            kind: 'field',
            label: { en: 'Hydra serum 30 ml — 33 €', ua: 'Сироватка Hydra 30 мл — 1 490 ₴' },
            value: '',
            issue: {
              en: 'The page shows 33 €; the approved price is 29 €. A wrong price means a refund and a complaint on every order.',
              ua: 'На сторінці 1 490 ₴; затверджена ціна — 1 290 ₴. Хибна ціна — це повернення й скарга на кожне замовлення.'
            }
          },
          {
            id: 'h5',
            kind: 'field',
            label: { en: 'Hydra cream 50 ml — 24 €', ua: 'Крем Hydra 50 мл — 1 090 ₴' },
            value: ''
          },
          {
            id: 'h6',
            kind: 'line',
            label: {
              en: 'Free shiping on orders over 50 €',
              ua: 'Безкоштовна достака від 2 200 ₴'
            },
            value: '',
            issue: {
              en: '"Shiping" is a typo, in the one line about money. Typos on a price block read as a scam signal.',
              ua: '«Достака» — одруківка, і саме в рядку про гроші. Одруківки біля ціни читаються як ознака шахрайства.'
            }
          },
          {
            id: 'h7',
            kind: 'button',
            label: { en: 'Buy now', ua: 'Купити' },
            value: '→ /blog/hydra-story',
            issue: {
              en: 'The buy button links to a blog post. Every click from the ads lands on a story instead of the cart.',
              ua: 'Кнопка купівлі веде на пост у блозі. Кожен клік із реклами потрапляє на історію замість кошика.'
            }
          },
          {
            id: 'h8',
            kind: 'note',
            label: { en: 'Customer rating', ua: 'Оцінка клієнтів' },
            value: '4.8 ★ (212)'
          }
        ]
      },
      explain: {
        en: 'The serum is priced at 33 € against 29 € on the list; "cures acne" is a medical claim cosmetics cannot make; "shiping" is a typo in the one line about money; and the buy button sends paid traffic to the blog. The last one alone would have silently wasted Thursday’s whole budget.',
        ua: 'Ціна сироватки — 1 490 ₴ проти 1 290 ₴ у прайсі; «лікує акне» — медичне твердження, якого косметика робити не може; «достака» — одруківка в єдиному рядку про гроші; а кнопка купівлі відправляє платний трафік у блог. Сама лише остання помилка тихо спалила б увесь бюджет четверга.'
      },
      fx: { ok: { conversion: 6, brand: 4 }, fail: { conversion: -5, brand: -3 } }
    },
    {
      type: 'chat',
      id: 's8',
      at: '16:00',
      comp: ['communication', 'ethics'],
      traits: ['S', 'E'],
      messages: [
        {
          from: 'support',
          text: {
            en: 'A customer posted a video: the Hydra tester sample she got at the pop-up gave her a rash. 40 000 views in three hours, comments are piling up, two beauty blogs have shared it.',
            ua: 'Клієнтка виклала відео: від пробника Hydra, який їй дали на поп-апі, у неї висип. 40 000 переглядів за три години, коментарі сиплються, два б’юті-блоги вже поширили.'
          }
        },
        {
          from: 'founder',
          text: {
            en: 'Can we get the video taken down? Or at least say it is not our product? It is two days before launch.',
            ua: 'Можемо домогтися, щоб відео прибрали? Або хоча б сказати, що це не наш продукт? Два дні до запуску.'
          }
        }
      ],
      prompt: { en: 'What do you do in the next hour?', ua: 'Що робиш у найближчу годину?' },
      options: [
        {
          text: {
            en: 'Reply publicly under the video within the hour: sorry this happened, we have contacted you directly, here is the full ingredient list and our safety testing. Then call her and send the batch to the lab.',
            ua: 'Публічно відповісти під відео протягом години: нам шкода, що так сталося, ми написали вам особисто, ось повний склад і дані про тестування безпеки. Потім подзвонити клієнтці й передати номер партії в лабораторію.'
          },
          q: 'best',
          fx: { brand: 6, trust: 3, reach: -1 },
          fb: {
            en: 'People judge the brand by the reply, not the rash. A fast, human, factual answer in public turns the thread from "what are they hiding" into "they handled it".',
            ua: 'Про бренд судять за відповіддю, а не за висипом. Швидка, людяна й фактична публічна відповідь перетворює тред із «що вони приховують» на «вони впоралися».'
          }
        },
        {
          text: {
            en: 'Contact the customer privately first, offer a refund and a dermatologist visit, and post a short public statement tomorrow once you know what the lab says about the batch.',
            ua: 'Спершу зв’язатися з клієнткою приватно, запропонувати повернення коштів і візит до дерматолога, а коротку публічну заяву дати завтра, коли лабораторія відповість про партію.'
          },
          q: 'ok',
          fx: { brand: 1, trust: 1 },
          fb: {
            en: 'Right instincts, wrong clock. By tomorrow the video has 200 000 views and the comments have written your statement for you.',
            ua: 'Правильні інстинкти, неправильний годинник. До завтра у відео 200 000 переглядів, і коментарі вже написали твою заяву за тебе.'
          }
        },
        {
          text: {
            en: 'Ask the platform to remove the video for unverified medical claims, and have the agency push positive creator posts to drown it out before Thursday morning.',
            ua: 'Попросити платформу видалити відео за неперевірені медичні твердження, а агенцію — залити позитивними постами блогерів, щоб перекрити його до четверга.'
          },
          q: 'bad',
          fx: { brand: -8, trust: -4 },
          fb: {
            en: 'A takedown request becomes the second video, and "the brand tried to silence me" travels further than a rash ever could.',
            ua: 'Запит на видалення стає другим відео, а «бренд намагався мене заткнути» розлітається далі, ніж будь-який висип.'
          }
        },
        {
          text: {
            en: 'Post a statement that the sample cannot be traced to a verified batch, so the brand cannot confirm that it is a genuine Hydra product, and leave it at that for now.',
            ua: 'Опублікувати заяву, що пробник не вдається відстежити до перевіреної партії, тож бренд не може підтвердити, що це справжній продукт Hydra, і на цьому зупинитися.'
          },
          q: 'bad',
          fx: { brand: -6, trust: -3 },
          fb: {
            en: 'Technically careful, publicly cold. The commenters read "we are calling her a liar", and the beauty blogs now have a second story.',
            ua: 'Технічно обережно, публічно холодно. Коментатори читають «ми називаємо її брехункою», а б’юті-блоги отримують другу історію.'
          }
        }
      ],
      principle: {
        en: 'In a crisis, speed and humanity beat precision.',
        ua: 'У кризі швидкість і людяність важливіші за точність.'
      }
    }
  ],
  verdict: {
    bands: [
      {
        min: 0.8,
        title: {
          en: 'You could run this launch tomorrow',
          ua: 'Ти міг би вести цей запуск уже завтра'
        },
        text: {
          en: 'You put budget on bets, said no to fake reach with numbers, and answered a crisis in public within the hour.',
          ua: 'Ти ставив бюджет на ставки, казав «ні» фальшивому охопленню цифрами й відповідав на кризу публічно протягом години.'
        }
      },
      {
        min: 0.6,
        title: {
          en: 'Solid marketer with a soft spot for shiny things',
          ua: 'Впевнений маркетолог зі слабкістю до блискучого'
        },
        text: {
          en: 'The plan and the analytics held; the misses were where a founder or a big number pulled you off course.',
          ua: 'План і аналітика трималися; промахи — там, де засновниця або велика цифра стягували тебе з курсу.'
        }
      },
      {
        min: 0.4,
        title: { en: 'You sell well and check little', ua: 'Ти добре продаєш і мало перевіряєш' },
        text: {
          en: 'Several choices trusted a claim, a screenshot or a follower count. Re-read the feedback on the creator and the landing page.',
          ua: 'Кілька рішень повірили твердженню, скриншоту або кількості підписників. Перечитай фідбек до блогерки й до лендингу.'
        }
      },
      {
        min: 0,
        title: {
          en: 'This launch would have burned the budget by Friday',
          ua: 'Цей запуск спалив би бюджет до п’ятниці'
        },
        text: {
          en: 'Many choices optimised for pleasing the loudest person in the room. The job is the opposite: protect the plan and the brand when it is uncomfortable.',
          ua: 'Багато рішень були про те, щоб догодити найгучнішій людині в кімнаті. Робота ж навпаки: захищати план і бренд, коли це незручно.'
        }
      }
    ],
    reality: [
      {
        en: 'About a third of the week is spreadsheets: budgets, CAC by channel, invoices from agencies with lines you did not order.',
        ua: 'Приблизно третина тижня — таблиці: бюджети, CAC за каналами, рахунки від агенцій із рядками, яких ти не замовляв.'
      },
      {
        en: 'You write or approve 20–30 pieces of copy a week, and most of your edits are about a price, a claim or a typo.',
        ua: 'Ти пишеш або погоджуєш 20–30 текстів на тиждень, і більшість правок — про ціну, твердження або одруківку.'
      },
      {
        en: 'Once a month something blows up in public, and the next hour matters more than the next campaign.',
        ua: 'Раз на місяць щось вибухає публічно, і наступна година важить більше за наступну кампанію.'
      }
    ]
  }
};
